import * as React from 'react';
// @ts-expect-error
import type {DragHandleProps} from 'react-beautiful-dnd';

import {DraggableRow} from 'shells/draggable-row/draggable-row';
import {SyncRegularIcon} from 'shells/icon/svg/sync-regular-icon';
import {TwoRowItem} from 'shells/two-row-item/two-row-item';

import type {EntityFilterFieldConfig as EntityFilterFieldConfigFragment} from 'nutshell-graphql-types';

import {ReadableCriteria} from './readable-criteria';
import type {UserAssignmentAutomation} from './user-assignments-types';

import styles from './special-case-item.module.css';

type Assignee = UserAssignmentAutomation['assignee'];

type Props = {
    dragHandleProps: DragHandleProps;
    assignee: Assignee;
    shouldUnassign: boolean;
    shouldRoundRobin: boolean | null | undefined;
    criteria: EntityFilterFieldConfigFragment;
    onRemove: () => void;
};

export function SpecialCaseItem(props: Props) {
    const topRow = (
        <div>
            <div className={styles.name}>
                {getDisplayName(props.assignee, props.shouldUnassign)}
            </div>
            {props.shouldRoundRobin ? (
                <div className={styles['round-robin']}>
                    <SyncRegularIcon size={12} />
                </div>
            ) : null}
        </div>
    );

    const bottomRow = <ReadableCriteria criteria={props.criteria} />;

    return (
        <DraggableRow dragHandleProps={props.dragHandleProps}>
            <TwoRowItem topRow={topRow} bottomRow={bottomRow} onRemove={props.onRemove} />
        </DraggableRow>
    );
}

function getDisplayName(assignee: Assignee, shouldUnassign: boolean) {
    if (assignee) return assignee.name;

    if (shouldUnassign) return 'Unassign lead';

    return '';
}
